package navigation

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

class MainViewModel {
    private val _currentScreen = MutableStateFlow<Screen>(Screen.Cliente)
    val currentScreen: StateFlow<Screen> = _currentScreen.asStateFlow()

    // FIX #20: Back stack para soporte de botón back del navegador
    private val backStack = mutableListOf<Screen>()

    fun navigateTo(screen: Screen) {
        val current = _currentScreen.value
        if (current != screen) {
            backStack.add(current)
            // Limitar back stack a 20 entradas para evitar memory leak en navegación repetida
            if (backStack.size > 20) backStack.removeAt(0)
            _currentScreen.value = screen
            org.example.abigail.pushBrowserState(screen::class.simpleName ?: "")
        }
    }

    /** Navegar hacia atrás. Retorna true si había pantalla previa. */
    fun navigateBack(): Boolean {
        if (backStack.isEmpty()) return false
        val previous = backStack.removeAt(backStack.size - 1)
        _currentScreen.value = previous
        return true
    }

    // ═══ Impersonar chofer (modo espectador para admin+) ═══
    // Cuando admin quiere ver el panel de un chofer específico, setea uid+nombre
    // y navega a Screen.Chofer. Al salir se limpia y vuelve al panel admin.
    private val _impersonarChoferUid = MutableStateFlow<String?>(null)
    val impersonarChoferUid: StateFlow<String?> = _impersonarChoferUid.asStateFlow()
    private val _impersonarChoferNombre = MutableStateFlow<String?>(null)
    val impersonarChoferNombre: StateFlow<String?> = _impersonarChoferNombre.asStateFlow()

    fun verPanelComoChofer(uid: String, nombre: String) {
        _impersonarChoferUid.value = uid
        _impersonarChoferNombre.value = nombre
        navigateTo(Screen.Chofer)
    }

    fun limpiarImpersonarChofer() {
        _impersonarChoferUid.value = null
        _impersonarChoferNombre.value = null
    }
}